import { Component, OnInit, Input, ViewChild, Injector } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Product, ProductSearchRequest, ListOfProducts, FirebaseParameter } from 'src/app/models/product';
import { ProductService } from 'src/app/services/product.service';
import { CartService } from 'src/app/services/cart.service';
import { ProductSuccessAddComponent } from '../product-success-add/product-success-add.component';
import { AdminHeaderComponent } from 'src/app/layouts/admin-header/admin-header.component';
import * as firebase from 'firebase';
import { formatDate } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-detail-product',
  templateUrl: './detail-product.component.html',
  styleUrls: ['./detail-product.component.css']
})
export class DetailProductComponent implements OnInit {
  public keywordSearchText = '';
  public productSearchQueryParam: ProductSearchRequest = new ProductSearchRequest();
  listOfProduct: FirebaseParameter[] = ListOfProducts;
  isLoadingStock: boolean = false;
  stock: number = 0;
  listPromo = [];
  displayNetPrice = false;
  expireDate = '';
  isLoadingExpireDate = false;

  @Input() public product: Product;
  @ViewChild('addToCartModal') addToCartModal: ProductSuccessAddComponent;
  @ViewChild(AdminHeaderComponent) header: AdminHeaderComponent;

  constructor(
    public productService: ProductService,
    public cartService: CartService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getProductDetail();

    $('body').on('keypress', 'input[type=number][maxlength]', function (event) {
      var key = event.keyCode || event.charCode;
      var txtVal = $(this).val();
      var maxlength = $(this).attr('maxlength');
      if (key > 31 && (key < 48 || key > 57)) {
        return false;
      }
      if (txtVal.length == maxlength) {
        event.preventDefault();
        return false;
      }
      return true;
    });

    $('body').on('paste', 'input[type=number][maxlength]', function (event) {
      return false;
    });
  }

  getProductDetail() {
    const data = this.route.snapshot.paramMap.get('data');
    if (data != null) {
      try {
        this.product = JSON.parse(atob(data));

        const target = this.listOfProduct.find(x => x.code === this.product.code.toLowerCase());
        if (target) {
          firebase.analytics().logEvent(target.event, { detail_produk: target.value });
        }

        this.keywordSearchText = this.product.code;
        this.getProduct();

      } catch { this.product = null; }
    }

    if (this.product === null) {
      this.router.navigate(['product']);
    } else {
      this.loadStock();
      this.getExpireDateProduct();
    }
  }

  getProduct(): void {
    this.productSearchQueryParam.src = this.keywordSearchText;
    this.productSearchQueryParam.lim = 1;
    this.productSearchQueryParam.off = 0;
    this.productService.getProducts(this.productSearchQueryParam,
      (data) => {
        if (data !== null && data.length > 0) {
          this.product = data[0];
          this.getPromo();
        }
      },
      (err) => {
        console.log(err);
      });
  }

  // CR10
  getPromo() {
    const paramPromo = {
      customerCode: JSON.parse(localStorage.getItem('user-profile')).customer_code,
      branch: JSON.parse(localStorage.getItem('user-profile')).branch_id,
      productCodes: [this.product.code]
    };

    this.productService.getProductsPromo(paramPromo, (response) => {
      if (response[0].promotions && response[0].promotions.length > 0) {
        this.listPromo = response[0].promotions || [];
      }
    }, (err) => {
    });
  }

  loadStock() {
    this.isLoadingStock = true;
    this.productService.getProductStock(this.product.code, this.product.unit_of_measure,
      resp => {
        this.isLoadingStock = false;
        if (resp.alert.code === 200) {
          this.stock = resp.data;
        } else {
          console.log(resp);
        }
      },
      err => {
        this.isLoadingStock = false;
        console.log(err);
      });
  }

  public addToCart(product: Product): void {
    firebase.analytics().logEvent('order_add_to_cart_detail_button');

    this.addProductToCart(product);
  }

  private addProductToCart(product: Product, isBuyNow = false) {
    if (product.ref_quantity > 0) {
      this.cartService.addToCart(product.code, product.unit_of_measure, product.ref_quantity, product.product_category,
        (data) => {
          if (isBuyNow) {
            this.router.navigate(['/cart']);
          } else {
            this.addToCartModal.showWithData(product, true);
            this.header.loadCart();
          }
        },
        (err) => {
          this.addToCartModal.showWithData(product, false, err);
        });
    } else {
      this.product.alert_message = 'Masukkan jumlah pesanan terlebih dahulu';
    }
  }

  public buyNow() {
    this.addProductToCart(this.product, true);
  }

  // CR-15
  getExpireDateProduct(): void {
    let productCode = [];
    productCode.push(this.product.code);

    const param = {
      productCode: productCode
    };

    this.isLoadingExpireDate = true;
    this.productService.getExpireDateProduct(param,
      (data) => {
        if (data[0].bathcEd === '0') {
          this.expireDate = '-';
        } else {
          this.expireDate = formatDate(data[0].bathcEd, 'dd MMMM yyyy', 'id');
        }

        this.isLoadingExpireDate = false;
      },
      (err) => {
        this.isLoadingExpireDate = false;
        console.log(err);
      }
    );
  }
}
